/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <g fill="#333" fillRule="evenodd">
      <path d="M256 323.49c-11.72 0-21.232-9.532-21.232-21.277v-35.095c0-11.745 9.512-21.277 21.232-21.277 24.034 0 43.568-19.576 43.568-43.634 0-24.087-19.534-43.663-43.568-43.663-24.006 0-43.54 19.576-43.54 43.663 0 11.745-9.512 21.277-21.232 21.277-11.72 0-21.232-9.532-21.232-21.277 0-47.55 38.586-86.219 86.004-86.219 47.446 0 86.032 38.67 86.032 86.219 0 40.2-27.602 74.047-64.8 83.523v16.483c0 11.745-9.512 21.278-21.232 21.278" />
      <path d="M256.139 43.22c-117.23 0-212.575 95.581-212.575 213.035S138.91 469.29 256.14 469.29c117.228 0 212.574-95.58 212.574-213.035 0-117.454-95.346-213.034-212.574-213.034m0 468.625C115.498 511.846 1.1 397.172 1.1 256.256 1.1 115.338 115.498.664 256.14.664c140.64 0 255.038 114.674 255.038 255.59 0 140.917-114.398 255.59-255.038 255.59" />
      <path d="M284.722 378.246c0 15.83-12.795 28.654-28.592 28.654-15.797 0-28.592-12.823-28.592-28.654 0-15.83 12.795-28.654 28.592-28.654 15.797 0 28.592 12.823 28.592 28.654" />
    </g>
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconInfo = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconInfo.defaultProps = {
  theme,
};
IconInfo.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconInfo.displayName = 'IconInfo';
export { IconInfo };
